import { connect } from "react-redux";
import { getIssues } from "../../../reducer";
import IssueList from "./IssueList";
import { Creators as DataCreators } from "../../../../data/reducer";

export default connect(
  (state, ownProps) => ({
    issues: getIssues(state, ownProps.customer.key)
  }),
  dispatch => ({
    onDataReceived: (path, data) =>
      dispatch(DataCreators.dataReceived(path, data))
  })
)(IssueList);



// WEBPACK FOOTER //
// ./src/customer/components/EditCustomer/IssueList/index.js